import React, { useState } from 'react';

import {
  IconeFeu,
} from './IconesSVG';

export default function ListeParFiliale({ pochettes, onSelect, selected, renderCard }) {
  const [filialeOuverte, setFilialeOuverte] = useState(null);

  const groupesFiliale = pochettes.reduce((acc, p) => {
    const filialeId = p.filiale?.id || p.filiale?._id || p.filiale_id || 'inconnu';
    const filiale = p.filiale || { id: filialeId, code: '?', nom: 'Filiale inconnue', couleur: '#888' };
    if (!acc[filialeId]) acc[filialeId] = { filiale, pochettes: [] };
    acc[filialeId].pochettes.push(p);
    return acc;
  }, {});

  const groupes = Object.values(groupesFiliale).sort((a, b) =>
    a.filiale.nom.localeCompare(b.filiale.nom)
  );

  // Si une seule filiale, afficher directement la liste sans cards
  if (groupes.length <= 1) {
    const liste = groupes[0]?.pochettes || [];
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '4px' }}>
        {liste.map(p =>
          renderCard ? renderCard(p, selected?.id === p.id) : (
            <DefaultPochetteCard key={p.id} p={p} isSelected={selected?.id === p.id} onSelect={onSelect} />
          )
        )}
      </div>
    );
  }

  const filialeCourante = filialeOuverte
    ? groupes.find(g => (g.filiale.id || g.filiale._id) === filialeOuverte)
    : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, padding: '4px' }}>

      {/* GRILLE DE CARDS FILIALES */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
        gap: 10,
      }}>
        {groupes.map(({ filiale, pochettes: listePochettes }) => {
          const filialeId = filiale.id || filiale._id;
          const isOuverte = filialeOuverte === filialeId;
          const couleur = filiale.couleur || '#2980B9';
          const nb = listePochettes.length;
          const nbUrgents = listePochettes.filter(p => p.priorite === 'P1').length;
          const bgCouleur = couleur + '18';
          const borderCouleur = couleur + '40';

          return (
            <div
              key={filialeId}
              onClick={() => setFilialeOuverte(isOuverte ? null : filialeId)}
              style={{
                background: isOuverte ? couleur + '12' : '#fff',
                border: isOuverte ? `2px solid ${couleur}` : nbUrgents > 0 ? '1.5px solid #C0392B' : '1px solid #e5e7eb',
                borderRadius: 14,
                padding: '16px 12px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: isOuverte ? `0 4px 16px ${couleur}25` : '0 2px 6px rgba(0,0,0,0.05)',
              }}
            >
              {/* Logo / Badge filiale */}
              <div style={{
                width: 52, height: 52, borderRadius: 14,
                background: bgCouleur,
                border: `1px solid ${borderCouleur}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 10px',
                overflow: 'hidden',
              }}>
                {filiale.logo ? (
                  <img
                    src={(process.env.REACT_APP_STATIC_URL || 'http://localhost:5001') + '/' + filiale.logo}
                    alt={filiale.code}
                    style={{ width: 40, height: 40, objectFit: 'contain' }}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                ) : (
                  <span style={{ fontSize: 12, fontWeight: 700, color: couleur }}>
                    {filiale.code?.slice(0, 3)}
                  </span>
                )}
              </div>

              {/* Nom filiale */}
              <div style={{
                fontSize: 12, fontWeight: 700, color: '#0D1B2A',
                marginBottom: 2, overflow: 'hidden',
                textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                {filiale.nom?.length > 18 ? filiale.code : filiale.nom}
              </div>
              <div style={{ fontSize: 10, color: '#888', marginBottom: 12 }}>{filiale.code}</div>

              {/* Badge compteur */}
              <div style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: isOuverte ? couleur : couleur + '20',
                color: isOuverte ? '#fff' : couleur,
                borderRadius: 20, padding: '5px 18px',
                fontSize: 22, fontWeight: 800,
                marginBottom: 6,
                transition: 'all 0.2s',
              }}>
                {nb}
              </div>

              {/* Sous-texte */}
              {nbUrgents > 0 ? (
                <div style={{ fontSize: 10, color: '#C0392B', fontWeight: 700 }}>
                  <IconeFeu taille={11} /> {nbUrgents} urgent{nbUrgents > 1 ? 's' : ''}
                </div>
              ) : (
                <div style={{ fontSize: 10, color: '#888' }}>
                  dossier{nb > 1 ? 's' : ''} en attente
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* LISTE DES POCHETTES DE LA FILIALE SELECTIONNEE */}
      {filialeCourante && (
        <div style={{
          background: '#FAFBFC',
          border: `1.5px solid ${filialeCourante.filiale.couleur || '#2980B9'}30`,
          borderRadius: 12,
          padding: '12px',
          animation: 'slideDown 0.2s ease',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8,
            marginBottom: 10, paddingBottom: 8,
            borderBottom: `1px solid ${filialeCourante.filiale.couleur || '#2980B9'}20`,
          }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: filialeCourante.filiale.couleur || '#2980B9' }}>
              {filialeCourante.filiale.code}
            </span>
            <span style={{ fontSize: 12, color: '#888' }}>
              — {filialeCourante.filiale.nom} · {filialeCourante.pochettes.length} dossier{filialeCourante.pochettes.length > 1 ? 's' : ''}
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {filialeCourante.pochettes.map(p =>
              renderCard ? renderCard(p, selected?.id === p.id) : (
                <DefaultPochetteCard key={p.id} p={p} isSelected={selected?.id === p.id} onSelect={onSelect} />
              )
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

function DefaultPochetteCard({ p, isSelected, onSelect }) {
  const prioriteColor = p.priorite === 'P1' ? '#C0392B' : p.priorite === 'P2' ? '#9A7D0A' : '#2980B9';
  const prioriteBg   = p.priorite === 'P1' ? '#FDEDEC' : p.priorite === 'P2' ? '#FEF9E7' : '#EAF4FB';
  return (
    <div
      onClick={() => onSelect && onSelect(p)}
      style={{
        padding: '10px 14px', borderRadius: 10,
        border: isSelected ? '2px solid #2980B9' : '1px solid #e5e7eb',
        background: isSelected ? '#EAF4FB' : '#fff',
        cursor: 'pointer', transition: '0.15s',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#0D1B2A' }}>{p.reference}</span>
        <span style={{ fontSize: 10, background: prioriteBg, color: prioriteColor, padding: '2px 8px', borderRadius: 10, fontWeight: 700 }}>
          {p.priorite}
        </span>
      </div>
      <div style={{ fontSize: 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 4 }}>
        {p.titre || p.motif || '—'}
      </div>
      <div style={{ fontSize: 11, color: '#888' }}>
        {p.demandeur?.prenom} {p.demandeur?.nom} · {new Date(p.created_at).toLocaleDateString('fr-FR')}
      </div>
    </div>
  );
}
